import { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import { SettingsContext } from "../../providers/SettingsProvider";
import { AuthContext } from "../../providers/AuthProvider";
import { tgLink } from "../../constants";
import { getDefaultPrivateLeagueId } from "../../helpers/user";

const MobileMenu = ({
  show,
  handleClose,
  showSupportPopup = () => undefined,
}) => {
  const navigate = useNavigate();
  const { season } = useContext(SettingsContext);

  const { user } = useContext(AuthContext);

  const isAdmin = Boolean(user?.me?.isAdmin);

  const favTeamId = user?.me?.favTeamId || 85465;
  const defaultPrivateLeagueId = getDefaultPrivateLeagueId(
    user?.me?.privateLeagues,
  );

  const onItemClick = (action) => {
    handleClose();
    switch (action) {
      case "administration":
        navigate(`/administration`);
        break;
      case "club-leagues":
        navigate(`/leagues/${favTeamId}`);
        break;
      case "private-leagues":
        navigate(`/private-leagues/${defaultPrivateLeagueId}`);
        break;
      case "archive":
        navigate(`/archived/${season - 1}`);
        break;
      case "support":
        showSupportPopup();
        break;
      case "rules":
        navigate(`/rules`);
        break;
      case "telegram":
        window.open(tgLink, "_blank");
        break;
      case "privacy-policy":
        navigate(`/privacy-policy`);
        break;
      case "terms-of-service":
        navigate(`/terms-of-service`);
        break;
      case "stats":
        navigate("/stats");
        break;
      case "logout":
        navigate("/logout");
        break;
      default:
        break;
    }
  };

  return (
    <Offcanvas
      className={styles.canvas}
      show={show}
      onHide={handleClose}
      placement="bottom"
    >
      <Offcanvas.Header
        className={styles.header}
        closeButton
      ></Offcanvas.Header>{" "}
      <Offcanvas.Body className={styles.body}>
        {isAdmin && (
          <div
            className={styles.menuItem}
            onClick={() => onItemClick("administration")}
          >
            <i className="bi bi-people-fill"></i>&nbsp;Адмінка
          </div>
        )}
        <hr />
        <div
          className={styles.menuItem}
          onClick={() => onItemClick("club-leagues")}
        >
          <i className="bi bi-list-task"></i>&nbsp;Клубні ліги
        </div>
        <div
          className={styles.menuItem}
          onClick={() => onItemClick("private-leagues")}
        >
          <i className="bi bi-incognito"></i>&nbsp;Приватні ліги
        </div>
        <div className={styles.menuItem} onClick={() => onItemClick("stats")}>
          <i className="bi bi-pie-chart"></i>&nbsp;Центр статистики
        </div>
        <div className={styles.menuItem} onClick={() => onItemClick("archive")}>
          <i className="bi bi-archive"></i>&nbsp;Архів
        </div>
        <hr />
        <div className={styles.menuItem} onClick={() => onItemClick("rules")}>
          <i className="bi bi-paperclip"></i>&nbsp;Правила гри
        </div>
        <div
          className={styles.menuItem}
          onClick={() => onItemClick("terms-of-service")}
        >
          <i className="bi bi-file-check"></i>&nbsp;Угода користувача
        </div>
        <div
          className={styles.menuItem}
          onClick={() => onItemClick("privacy-policy")}
        >
          <i className="bi bi-cookie"></i>&nbsp;Використання cookies
        </div>
        <hr />
        <div
          className={styles.menuItem}
          onClick={() => onItemClick("telegram")}
        >
          <i className="bi bi-telegram"></i>&nbsp;Офіційний канал
        </div>
        <div className={styles.menuItem} onClick={() => onItemClick("support")}>
          <i className="bi bi-headset"></i>&nbsp;Техпідтримка
        </div>
        <hr />
        <div className={styles.menuItem} onClick={() => onItemClick("logout")}>
          <i className="bi bi-box-arrow-right"></i>&nbsp;Вийти
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileMenu;
